export default __webpack_public_path__ + "static/AXS-b7cb65ea5eca611dbe5c4435884197c8.jpg";